"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandError_1 = __importDefault(require("./GraphandError"));
var GraphandValidationErrorCodes;
(function (GraphandValidationErrorCodes) {
    GraphandValidationErrorCodes["UNKNOWN"] = "unknown";
    GraphandValidationErrorCodes["REQUIRED"] = "required";
    GraphandValidationErrorCodes["UNIQUE"] = "unique";
    GraphandValidationErrorCodes["RESTRICTED"] = "restricted";
    GraphandValidationErrorCodes["NOT_FOUND"] = "not_found";
    GraphandValidationErrorCodes["INVALID"] = "invalid";
    GraphandValidationErrorCodes["WEBHOOK"] = "webhook";
})(GraphandValidationErrorCodes || (GraphandValidationErrorCodes = {}));
class GraphandValidationError extends GraphandError_1.default {
    constructor(message = "Unknown validation error", field, code = GraphandValidationErrorCodes.UNKNOWN) {
        super(message, code, 400);
        Object.assign(this, { field });
    }
    toJSON() {
        return {
            type: this.name,
            message: this.message,
            code: this.code,
            field: this.field,
            argument: this.argument,
        };
    }
}
GraphandValidationError.Codes = GraphandValidationErrorCodes;
exports.default = GraphandValidationError;
